import { api, setConfig } from '../..';
import { mapEntityToApi, mapApiToEntity } from './mapper';
import { PropertyType } from '../../../common';

export const getFreeSpinsCampaigns = (data: PropertyType): Promise<PropertyType> =>
	api.post(`esa-tools/free-spins${data?.query}`, mapEntityToApi(data), setConfig(data)).then((res) => {
		return mapApiToEntity(res.data);
	});
